/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import { labelStyle, rootStyle } from "./styles";

import type { ReactElement, ReactNode } from "react";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  checkboxElement: ReactElement;
  labelText: ReactNode;
};

export const CheckboxField: FcWithoutChildren<Props> = (props) => {
  const { checkboxElement, labelText } = props;

  return (
    <fieldset css={rootStyle}>
      <label css={labelStyle}>
        {checkboxElement}
        {labelText}
      </label>
    </fieldset>
  );
};
